<template>
    <div></div>
</template>

<script>

    import UserUtils from '../mixins/UserUtils';

    export default {

        mixins: [  UserUtils ],

        data() {
            return {
                hub_url : window.env.HUB_URL,
                domain_url : window.env.DOMAIN_URL
            }
        },

        beforeMount(){
            /*
            * if backUrl is exist in localStorage than it'll redirect to backUrl
            * Generate URL and unset backUrl localStorage value and redirect to same page
            * else redirect to myAccount
            * */
            let backUrl = this.getLocalStorageData(this.getBackToUrl())
            if(backUrl){
                let url = /^(http:\/|https:\/)/.test(backUrl) ? backUrl : this.domain_url + this.getLocalStorageData(this.getBackToUrl());
                this.unsetLocalStorageData(this.getBackToUrl());
                window.location = url;
            } else {
                window.location = this.hub_url;
            }
        }
    }
</script>

<style scoped>

</style>
